export const useKeyboardLayout = () => {
  const layoutHeight = '104%';
  const isKeyboardVisible = false;

  return { layoutHeight, isKeyboardVisible };
};
